import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';

const OfferPartnerBankAccountSummary = ({ bankAccounts }) => {
  const defaultBankAccounts = bankAccounts.filter(item => item.defaultAccount === true);
  const existDefaultBankAccount = bankAccounts.length > 0;

  return (
    <Grid container spacing={1}>
      <Grid item xs={4} sm={4} md={6}>
        <span>
          {defaultBankAccounts &&
            existDefaultBankAccount &&
            defaultBankAccounts.map((item, idx) => {
              return (
                <div key={idx}>
                  {item.bankName || ''} / {item.bankAccount || ''} / {item.currencyCode || ''}
                </div>
              );
            })}
        </span>
      </Grid>
    </Grid>
  );
};

OfferPartnerBankAccountSummary.propTypes = {
  bankAccounts: PropTypes.array
};

export default OfferPartnerBankAccountSummary;
